module.exports = __webpack_public_path__ + "img/48.cleaner_arrived.a30cd315.svg";